<template>
  <div class="netpa-page-panel row">
    <div class="col-12">
      <header
        class="w-100 netpa-page-panel__alert"
        :class="ClassCustom"
        dir="rtl"
      >
        <div class="netpa-page-panel__content">
          <i
            class="fas fa-info-circle netpa-page-panel__icon"
            aria-hidden="true"
          ></i>
          <p class="netpa-page-panel__desc">{{ hintText }}</p>
        </div>
        <button
          v-if="IsBtnBack == true"
          type="button"
          class="netpa-page-panel__back-btn"
          title="بازگشت به صفحه قبلی"
          aria-label="بازگشت به صفحه قبلی"
          @click="Back"
        >
          <i class="fas fa-arrow-left" aria-hidden="true"></i>
        </button>
        <button
          v-if="IsBtnClose == true"
          type="button"
          class="netpa-page-panel__back-btn"
          title="بستن"
          aria-label="بستن"
          data-dismiss="modal"
        >
          <i class="fas fa-times" aria-hidden="true"></i>
        </button>
      </header>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  props: ["Title", "Des", "ClassCustom", "IsBtnBack", "IsBtnClose"],
  computed: {
    hintText() {
      if (this.Des != "" && this.Des != null) return this.Des;
      return this.Title;
    },
  },
  methods: {
    Back() {
      this.$router.go(-1);
    },
  },
};
</script>
<style scoped>
.netpa-page-panel {
  --bnp-brand-purple: #8d58a4;
  --bnp-brand-cyan: #05b8c8;
  --bnp-hint: #56508d;
  --bnp-hint-accent: #666ebf;
  --bnp-border-default: #d5e6f0;
  --bnp-focus-ring: 0 0 0 4px rgba(5, 184, 200, 0.2);
  margin-left: 0;
  margin-right: 0;
  margin-bottom: 12px;
  max-width: 100%;
}

.netpa-page-panel > .col-12 {
  padding-left: 0;
  padding-right: 0;
  max-width: 100%;
  min-width: 0;
}

.netpa-page-panel__alert,
.netpa-page-panel__alert.bg-dark-Custom {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: nowrap;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
  margin-bottom: 0;
  padding: 8px 12px;
  color: var(--bnp-hint);
  border: 1px solid var(--bnp-hint-accent);
  border-radius: 22px;
  corner-shape: squircle;
  background: #eef1fb !important;
  box-shadow: none;
}

.netpa-page-panel__content {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  flex: 1 1 auto;
  min-width: 0;
  text-align: right;
}

.netpa-page-panel__icon {
  flex: 0 0 auto;
  margin-top: 2px;
  color: var(--bnp-hint-accent);
  font-size: 14px;
}

.netpa-page-panel__desc {
  margin: 0;
  color: var(--bnp-hint);
  font-size: 13px;
  font-weight: 500;
  line-height: 1.7;
}

.netpa-page-panel__back-btn {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  margin: 0;
  color: #617185;
  border: 1px solid var(--bnp-border-default);
  border-radius: 14px;
  corner-shape: squircle;
  background: #fff;
  cursor: pointer;
  line-height: 1;
  transition:
    color 180ms ease,
    border-color 180ms ease,
    background 180ms ease;
}

.netpa-page-panel__back-btn i {
  font-size: 15px;
  pointer-events: none;
}

.netpa-page-panel__back-btn:hover {
  color: var(--bnp-brand-purple);
  border-color: rgba(141, 88, 164, 0.28);
  background: rgba(141, 88, 164, 0.05);
}

.netpa-page-panel__back-btn:focus {
  outline: none;
}

.netpa-page-panel__back-btn:focus-visible {
  border-color: var(--bnp-brand-cyan);
  box-shadow: var(--bnp-focus-ring);
}

@media (max-width: 767px) {
  .netpa-page-panel {
    margin-bottom: 10px;
  }

  .netpa-page-panel__alert,
  .netpa-page-panel__alert.bg-dark-Custom {
    align-items: flex-start;
    gap: 12px;
    padding: 8px 10px;
    border-radius: 18px;
    corner-shape: squircle;
  }
}

@media (prefers-reduced-motion: reduce) {
  .netpa-page-panel__back-btn {
    transition: none;
  }
}
</style>
